const MainArea = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) => {
  // A plain <div>, not <main>: Carbon's <Content> (rendered by AppShell)
  // already is a <main class="cds--content">, and nesting a second <main>
  // inside it is two landmarks, one inside the other — invalid HTML and a
  // duplicated landmark for assistive tech.
  //
  // min-h-[calc(100vh-3rem)], not min-h-screen: this now sits inside
  // .cds--content, which AppShell's shell adds a 3rem top margin to. A
  // full 100vh here would unconditionally make the document taller than
  // the viewport (100vh + 3rem), forcing a scrollbar even on an empty page.
  return (
    <div className="flex flex-col pb-10 bg-spectum-lightBlue min-h-[calc(100vh-3rem)]">
      {children}
    </div>
  );
};

export default MainArea;
